<script lang="ts" setup>
import type { FormResult } from '~kui/types/formResult';

import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const props = defineProps<FormResult>();

const textAlertVariant = computed(() =>
  twMerge(
    cva('flex w-full items-center justify-center text-center font-semibold', {
      variants: {
        variant: {
          success: 'text-success-foreground',
          error: 'text-destructive',
          info: 'text-foreground',
          warning: 'text-muted-foreground font-semibold',
        },
      },
    })({
      variant: props.variant,
    }),
  ),
);
</script>

<template>
  <div :class="textAlertVariant" :data-testid="`kui-alert-message-text-${variant}`">
    <p>
      {{ message }}
    </p>
  </div>
</template>
